import useProfile from '@/queries/useProfile';
import { setBearerToken } from '@/services/apiService';
import { handleLocalStorage } from '@/utils/handleLocalStorage';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import PreLoading from '../PreLoading';
import useStoreApp from '@/store';

function PublicRoute({ children }: any) {

  const router = useRouter();
  const { from } = router.query as { from: string | null };
  const { status } = useProfile();

  const { isEmbeed, setIsEmbeed } = useStoreApp(state => state.globalSlice);

  const isInvoiceDirectAccess = router.pathname.includes('/invoice') && !!router.query.secretKey;

  if (typeof window !== 'undefined') {
    if (isInvoiceDirectAccess) {
      // skip token setting
    } else if (from === 'hoiango.com') {
      //console.log('clear token when from hoiango.com');
      setBearerToken(null);
    } else {
      setBearerToken(handleLocalStorage.get('accessToken')!);
    }
  }

  useEffect(() => {
    if (isInvoiceDirectAccess) return;

    const isFromEmbeed = from === 'hoiango.com';

    if (isFromEmbeed !== isEmbeed) {
      setIsEmbeed(isFromEmbeed);
    }

    if (status === 'loading') return;

    if (status === 'success') {

      if (isEmbeed) {

        router.push({
          pathname: '/',
          query: {
            ...router.query,
          }
        });
      }
      else {
        router.push({
          pathname: '/dashboard',
          query: { ...router.query }
        });
      }
    }
  }, [status]);

  if (isInvoiceDirectAccess || status === 'error' || (status === 'success' && isEmbeed)) {
    return children;
  }

  return <PreLoading />;
}

export default PublicRoute;
